module.exports = __webpack_public_path__ + "img/gem-dark.6d22519c.png";